"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = void 0;
var ErrorType;
(function (ErrorType) {
    ErrorType["USER_CANCELLED"] = "USER_CANCELLED";
    ErrorType["UNKNOWN_SERVER_TYPE"] = "UNKNOWN_SERVER_TYPE";
    ErrorType["UNKNOWN_INTERFACE"] = "UNKNOWN_INTERFACE";
    ErrorType["TIMEOUT"] = "TIMEOUT";
    ErrorType["CREDENTIAL_SERVER"] = "CREDENTIAL_SERVER";
    ErrorType["CREDENTIAL_NOTSUPPLIED"] = "CREDENTIAL_NOTSUPPLIED";
    ErrorType["CREDENTIAL_USER"] = "CREDENTIAL_USER";
    ErrorType["CREDENTIAL_PASSWORD"] = "CREDENTIAL_PASSWORD";
    ErrorType["CREDENTIAL_PRIVILEGE"] = "CREDENTIAL_PRIVILEGE";
    ErrorType["SYSTEM"] = "SYSTEM";
    ErrorType["UNKNOWN_HOST"] = "UNKNOWN_HOST";
    ErrorType["INCORRECT_HOST"] = "INCORRECT_HOST";
    ErrorType["NULL_RESPONSE"] = "NULL_RESPONSE";
    ErrorType["CONNECTION_REFUSED"] = "CONNECTION_REFUSED";
    ErrorType["CONNECTION_RESET"] = "CONNECTION_RESET";
    ErrorType["REQUIRES_SECURE_CONTEXT"] = "REQUIRES_SECURE_CONTEXT";
    ErrorType["NO_ROUTE_TO_HOST"] = "NO_ROUTE_TO_HOST";
    ErrorType["CERTIFICATE_LOCAL_NOT_FOUND"] = "CERTIFICATE_LOCAL_NOT_FOUND";
    ErrorType["CERTIFICATE_REMOTE_NOT_FOUND"] = "CERTIFICATE_REMOTE_NOT_FOUND";
    ErrorType["INSECURE_RESPONSE"] = "INSECURE_RESPONSE";
    ErrorType["FAILED_POST"] = "FAILED_POST";
    ErrorType["FAILED_JSON"] = "FAILED_JSON";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
